import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    current: {},
    currentLoading: false,
    additionalFees: [],
    additionalFeesLoading: false,
    divisionFees: [],
    divisionFeesLoading: false,
    eventFees: [],
    eventFeesLoading: false
  },
  mutations: {
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setAdditionalFees(state, payload) {
      state.additionalFees = payload;
    },
    setAdditionalFeesLoading(state, payload) {
      state.additionalFeesLoading = payload;
    },
    setDivisionFees(state, payload) {
      state.divisionFees = payload;
    },
    setDivisionFeesLoading(state, payload) {
      state.divisionFeesLoading = payload;
    },
    setEventFees(state, payload) {
      state.eventFees = payload;
    },
    setEventFeesLoading(state, payload) {
      state.eventFeesLoading = payload;
    }
  },
  actions: {
    async loadForCompetition({ commit }, competitions_id) {
      commit("setCurrentLoading", true);
      let list = await api.get("competition/invoiceSettings", {
        params: {
          competitions_id: competitions_id
        }
      });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },

    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`competition/invoiceSettings`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },

    // Additional Fees
    async loadAdditionalFees({ commit }, competitions_id) {
      commit("setAdditionalFeesLoading", true);
      let list = await api.get("competition/invoiceSettings/additional", {
        params: {
          competitions_id: competitions_id
        }
      });
      commit("setAdditionalFees", list.data);
      commit("setAdditionalFeesLoading", false);
    },
    async addAdditionalFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/additional`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAdditionalFees", payload.competitions_id);
      return returnData;
    },
    async saveAdditionalFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`competition/invoiceSettings/additional`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAdditionalFees", payload.competitions_id);
      return returnData;
    },
    async deleteAdditionalFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/additional/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAdditionalFees", payload.competitions_id);
      return returnData;
    },

    // Division Fees
    async loadDivisionFees({ commit }, competitions_id) {
      commit("setDivisionFeesLoading", true);
      let list = await api.get("competition/invoiceSettings/divisionFees", {
        params: {
          competitions_id: competitions_id
        }
      });
      commit("setDivisionFees", list.data);
      commit("setDivisionFeesLoading", false);
    },
    async addDivisionFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/divisionFee`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadDivisionFees", payload.competitions_id);
      return returnData;
    },
    async saveDivisionFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`competition/invoiceSettings/divisionFee`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadDivisionFees", payload.competitions_id);
      return returnData;
    },
    async deleteDivisionFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/divisionFee/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadDivisionFees", payload.competitions_id);
      return returnData;
    },

    // Event Fees
    async loadEventFees({ commit }, competitions_id) {
      commit("setEventFeesLoading", true);
      let list = await api.get("competition/invoiceSettings/eventFees", {
        params: {
          competitions_id: competitions_id
        }
      });
      commit("setEventFees", list.data);
      commit("setEventFeesLoading", false);
    },
    async addEventFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/eventFee`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadEventFees", payload.competitions_id);
      return returnData;
    },
    async saveEventFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`competition/invoiceSettings/eventFee`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadEventFees", payload.competitions_id);
      return returnData;
    },
    async deleteEventFee({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`competition/invoiceSettings/eventFee/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadEventFees", payload.competitions_id);
      return returnData;
    }
  },
  getters: {
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    additionalFees(state) {
      return state.additionalFees;
    },
    additionalFeesLoading(state) {
      return state.additionalFeesLoading;
    },
    divisionFees(state) {
      return state.divisionFees;
    },
    divisionFeesLoading(state) {
      return state.divisionFeesLoading;
    },
    eventFees(state) {
      return state.eventFees;
    },
    eventFeesLoading(state) {
      return state.eventFeesLoading;
    }
  }
};
